$(document).ready(function(){
  if($('.banner-slider-v1').length) {
   $('.banner_slider').slick({
  dots: true,
  autoplay: false,
  autoplaySpeed: 2000,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: false,
  nextArrow: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  }
   // for single product page variant on change 
   var $submitButton = $('.button-wrapper button[type="submit"]');
  if ($submitButton.is(':disabled')) {
      $submitButton.text('Out of stock');
    } else {
      $submitButton.text('Add To Cart');
    }
  $(".selector-wrapper select").on("change", function () {
    
    
    
    if ($submitButton.hasClass('disabled')) {
      $submitButton.text('Out of stock');
    } else {
      $submitButton.text('Add To Cart');
    }
  });
})

